import Axios from "axios";
import Qs from "qs";

import { INTERFACE } from "./getting";

function AsyncTo(promise) {
	return promise.then(data => [null, data]).catch(err => [err]);
}

async function EncaInterface({ name, params, mode = "get", ...opts }) {
	const [err, res] = await AsyncTo(Axios({
		data: mode === "post" ? Qs.stringify(params) : null,
		method: mode,
		url: `${INTERFACE[name]}${mode === "get" ? `?${Qs.stringify(params)}` : ""}`,
		...opts
	}));
	return [err, !err && res && res.status === 200 && res.data ? res.data : null];
}

function GetQueryParam(key = "") {
	if (key) {
		const reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
		const result = window.location.search.substr(1).match(reg);
		return result ? decodeURIComponent(result[2]) : null;
	} else {
		let match;
		const params = {};
		const reg = /([^&=]+)=?([^&]*)/g;
		const query = window.location.search.substr(1);
		const decode = str => decodeURIComponent(str.replace(/\+/g, " "));
		while ((match = reg.exec(query))) {
			params[decode(match[1])] = decode(match[2]);
		}
		return params;
	}
}

function GotoTop() {
	const currScroll = document.documentElement.scrollTop || document.body.scrollTop;
	if (currScroll > 0) {
		requestAnimationFrame(GotoTop);
		window.scrollTo(0, currScroll - (currScroll / 5));
	}
}

function GetType(tgt) {
	const type = Object.prototype.toString.call(tgt);
	return type.replace(/\[object /g, "").replace(/\]/g, "").toLowerCase();
}

function IsEmptyObject(tgt) {
	return IsObject(tgt) && !Object.keys(tgt).length;
}

function IsObject(tgt) {
	return GetType(tgt) === "object";
}

function RoundNum(n = 0, decimal = 2, percent = false) {
	if (percent) {
		return Math.round(n * 10 ** decimal * 100) / 10 ** decimal + "%";
	} else {
		return Math.round(n * 10 ** decimal) / 10 ** decimal;
	}
}

function ScriptCallback({ pst = "head", url = "", success = null, error = null }) {
	if ([...document.getElementsByTagName("script")].some(v => v.src === url || v.src.includes(url))) {
		return success && success();
	}
	const script = document.createElement("script");
	script.setAttribute("src", url);
	success && script.addEventListener("load", success);
	error && script.addEventListener("error", error);
	document[pst].appendChild(script);
}

function SetQueryParam(params = {}) {
	const obj = GetQueryParam();
	const newParams = Object.assign({}, obj, params);
	const query = Object.keys(newParams)
		.reduce((t, c) => `${t}${c}=${newParams[c]}&`, "?")
		.replace(/(&*$)/g, "");
	window.history.pushState({}, null, window.location.origin + window.location.pathname + query);
}

export {
	AsyncTo,
	EncaInterface,
	GetQueryParam,
	GotoTop,
	GetType,
	IsEmptyObject,
	IsObject,
	RoundNum,
	ScriptCallback,
	SetQueryParam
};